<!-- Canvas image of street view and action buttons -->
<div class="map-container" id="streetViewContainer{{index}}">
  <div class="address" *ngIf="!streetViewLoading">
    <div>
      <!-- Address -->
      <div class="d-flex mr-3">
        <label class="pt-0 mr-2">Address: </label>
        <div>{{locationInfo.ADDRESS}}</div>
      </div>
      <div class="d-flex">
        <div class="d-flex mr-3">
          <label class="pt-0 mr-2">Zip: </label>
          <div>{{locationInfo.ZIP}}</div>
        </div>
        <div class="d-flex mr-3">
          <label class="pt-0 mr-2">City: </label>
          <div>{{locationInfo.CITY}}</div>
        </div>
        <div class="d-flex">
          <label class="pt-0 mr-2">State: </label>
          <div>{{commonService.getStateName(locationInfo.STATE)}}</div>
        </div>
      </div>
    </div>
  </div>

  <div [hidden]="!isStreetView || isPagmanView">
    <div [hidden]="!isStreetViewAvailable">
      <!-- Canvas For Street View -->
      <div class="canvas-container" [hidden]="isCropMode || streetViewLoading">
        <canvas id="streetViewCanvas{{index}}" width="600" height="400"></canvas>
      </div>

      <!-- Loading bar -->
      <app-loader [loading]="streetViewLoading"></app-loader>

      <!-- Crop image -->
      <div [hidden]="!isCropMode" style="display: inline-block;">
        <div>
          <angular-cropper #angularCropper [cropperOptions]="cropConfig" imageUrl="{{streetViewImage}}">
          </angular-cropper>
        </div>
      </div>

      <!-- New Action buttons -->
      <div class="mapToolbar" *ngIf="isEditMode">
        <div class="row toolbar-container">
          <!-- Position -->
          <div class="col-4 p-0 section">
            <div class="section-name">Position</div>
            <div class="d-flex flex-wrap">
              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="viewLeft()"
                  title="View left &#013;Move map to the left"><i class="fa fa-arrow-left"></i></button>
                <div class="hint">Move map to the left</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="viewRight()"
                  title="View right &#013;Move map to the right"><i class="fa fa-arrow-right"></i></button>
                <div class="hint">Move map to the right</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="decreaseFov()"
                  title="View down &#013;Move map to the down"><i class="fa fa-plus"></i></button>
                <div class="hint">Zoom in over the map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="increaseFov()"
                  title="View top &#013;Move map to the top"><i class="fa fa-minus"></i></button>
                <div class="hint">Zoom out over the map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="viewTop()"
                  title="View top &#013;Move map to the top"><i class="fa fa-arrow-up"></i></button>
                <div class="hint">Move map to the top</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="viewDown()"
                  title="View down &#013;Move map to the down"><i class="fa fa-arrow-down"></i></button>
                <div class="hint">Move map to the down</div>
              </div>
            </div>
          </div>

          <!-- Draw -->
          <div class="col-4 pl-2 pr-0 section">
            <div class="section-name">Draw</div>
            <div class="d-flex flex-wrap">
              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="canvasService.addTextToCanvas(streetViewCanvas)"
                  title="Add Text &#013;Add Text on map"><i class="fa fa-font"></i></button>
                <div class="hint">Add Text on map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction"
                  (click)="canvasService.addCircleToCanvas(streetViewCanvas, streetViewBorderColor, streetViewStroke, streetViewStrokeWidth)"
                  title="Add Circle &#013;Add Circle on map"><i class="fa fa-circle-o"></i></button>
                <div class="hint">Add Circle on map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction squareIcon"
                  (click)="canvasService.addRectangleToCanvas(streetViewCanvas, streetViewBorderColor, streetViewStroke, streetViewStrokeWidth)"
                  title="Add Square &#013;Add Square on map"><i class="fa fa-square-o"></i></button>
                <div class="hint">Add Square on map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction"
                  (click)="canvasService.addArrowToCanvas(streetViewCanvas, streetViewStroke, streetViewStrokeWidth)"
                  title="Add Arrow &#013;Add Arrow on map"><i class="fa fa-long-arrow-right rotate225"></i></button>
                <div class="hint">Add Arrow on map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction"
                  (click)="canvasService.fillColor(streetViewCanvas, streetViewFillColor)"
                  title="Apply Color &#013;Add background color of selected shape"><i
                    class="fa fa-paint-brush"></i></button>
                <div class="hint">Fill Shape with Color</div>
              </div>

              <div class="hinted relative">
                <div class="btn-group" dropdown>
                  <button dropdownToggle type="button" class="map-action-button mapAction dropdown-toggle">
                    <hr class="shapeButtonBorder">
                  </button>
                  <ul *dropdownMenu class="borderDropdown dropdown-menu" role="menu">
                    <li role="menuitem" (click)="selectShapeBorderWidth(1)"><a class="borderDropdownItem dropdown-item">
                        <hr class="shape-border border1">
                      </a></li>
                    <li role="menuitem" (click)="selectShapeBorderWidth(2)"><a class="borderDropdownItem dropdown-item">
                        <hr class="shape-border border2">
                      </a></li>
                    <li role="menuitem" (click)="selectShapeBorderWidth(3)"><a class="borderDropdownItem dropdown-item">
                        <hr class="shape-border border3">
                      </a></li>
                    <li role="menuitem" (click)="selectShapeBorderWidth(4)"><a class="borderDropdownItem dropdown-item">
                        <hr class="shape-border border4">
                      </a></li>
                    <li role="menuitem" (click)="selectShapeBorderWidth(5)"><a class="borderDropdownItem dropdown-item">
                        <hr class="shape-border border5">
                      </a></li>
                    <li role="menuitem" (click)="selectShapeBorderWidth(6)"><a class="borderDropdownItem dropdown-item">
                        <hr class="shape-border border6">
                      </a></li>
                    <li role="menuitem" (click)="selectShapeBorderWidth(7)"><a class="borderDropdownItem dropdown-item">
                        <hr class="shape-border border7">
                      </a></li>
                  </ul>
                </div>
                <div class="hint">Select width of border</div>
              </div>

              <div class="hinted relative">
                <input class="color-picker-input" title="Fill Color &#013;Select background color for drawing item"
                  [style.background]="streetViewFillColor" [(colorPicker)]="streetViewFillColor"
                  (colorPickerOpen)="canvasService.changeFillColor('colorPickerOpen', $event, streetViewCanvas, streetViewFillColor)"
                  (colorPickerClose)="canvasService.changeFillColor('colorPickerClose', $event, streetViewCanvas, streetViewFillColor)"
                  (cpInputChange)="canvasService.changeFillColor('cpInputChange', $event, streetViewCanvas, streetViewFillColor)"
                  (cpSliderDragStart)="canvasService.changeFillColor('cpSliderDragStart', $event, streetViewCanvas, streetViewFillColor)"
                  (cpSliderDragEnd)="canvasService.changeFillColor('cpSliderDragEnd', $event, streetViewCanvas, streetViewFillColor)" />
                <div class="hint">Select background color for drawing item</div>
              </div>

              <div class="hinted relative">
                <input class="color-picker-input" title="Border Color &#013;Select color of border"
                  [style.background]="streetViewStroke" [(colorPicker)]="streetViewStroke"
                  (colorPickerOpen)="canvasService.changeBorderColor('colorPickerOpen', $event, streetViewCanvas, streetViewStroke)"
                  (colorPickerClose)="canvasService.changeBorderColor('colorPickerClose', $event, streetViewCanvas, streetViewStroke)"
                  (cpInputChange)="canvasService.changeBorderColor('cpInputChange', $event, streetViewCanvas, streetViewStroke)"
                  (cpSliderDragStart)="canvasService.changeBorderColor('cpSliderDragStart', $event, streetViewCanvas, streetViewStroke)"
                  (cpSliderDragEnd)="canvasService.changeBorderColor('cpSliderDragEnd', $event, streetViewCanvas, streetViewStroke)" />
                <div class="hint">Select color of border</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="canvasService.removeObject(streetViewCanvas)"
                  title="Remove &#013;Delete selected item"><i class="fa fa-trash"></i></button>
                <div class="hint">Remove Selected Shape</div>
              </div>
            </div>
          </div>

          <!-- Edit -->
          <div class="col-4 pl-2 pr-0 section">
            <div class="section-name">Manipulate</div>
            <div class="d-flex flex-wrap">
              <div class="hinted relative">
                <button class="{{isShowAnimation ? 'animated-button' : 'mode-toggle'}} map-action-button mapAction"
                  (click)="changeStreetView()" title="Change View"><i class="fa fa-retweet"></i></button>
                <div class="hint">Change viewing mode of the map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="cropAnImage()"
                  title="Crop &#013;Apply crop on existing image"><i
                    class="fa {{isCropMode ? 'fa-check' : 'fa-crop'}}"></i></button>
                <div class="hint">Apply crop on existing image</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="changePagmanView()" title="Change Pingman View"><i
                    class="fa fa-male"></i></button>
                <div class="hint">Change to the street view</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- If street view not available display this text -->
    <div class="error-container" *ngIf="!isStreetViewAvailable">
      <div class="error-data">
        <div class="warning-block">Block Warning</div>
        <div style="margin: 10px 0px;">No street view available for this location</div>
        <button type="button" class="btn btn-rbv" (click)="changePagmanView()"><i
            class="fa fa-plus warning-block-button"></i>Create Street View</button>
      </div>
    </div>

  </div>

  <!-- street view -->
  <div [hidden]="isStreetView || isPagmanView" id="streetViewBackButton{{index}}">
    <div class="street-view" id="street-view{{index}}"></div>
    <!-- Back Button -->
    <div class="mapToolbar">
      <button class="toggleButton map-action-button mapAction m-b-0" (click)="changeStreetView()" title="Change Mode"><i
          class="fa fa-retweet"></i></button>
    </div>
  </div>

  <!-- Pingman street view -->
  <div [hidden]="!isPagmanView">
    <div class="pagman-view" id="pagman-view{{index}}"></div>
    <!-- Back Button -->
    <div class="mapToolbar">
      <button class="map-action-button mapAction m-b-0" (click)="changePagmanView()" title="Back"><i
          class="fa fa-arrow-left"></i></button>
    </div>
  </div>
</div>
